import { ProductsList } from "src/modules/product/pages/ProductsList/ProdutsList"
import { ProductDetails } from "src/modules/product/pages/ProductDetails/ProductDetails";

const ProductConfig = {
    routes: {
        productDetails: {
            path: '/vehicles/:id-:slug',
            component: ProductDetails,
        },
        productDetailsById: {
            path: '/vehicles/:id',
            component: ProductDetails,
        },
        productsList: {
            path: '/vehicles',
            component: ProductsList,
        },
    },
}

export { ProductConfig }
